import { type LocationArt, type Sitzordnung } from '../../../../dtos';

export type FilterParameters = {
  raumSapIds: number[];
  regionSapIds: number[];
  standortSapIds: number[];
  locationSapIds: number[];
  locationArten: LocationArt[];
  raumgroesse: number | null;
  freieTage: number | null;
  locationHatGruppenraum: boolean | null;
  sitzordnung: Sitzordnung | null;
  teilnehmerErwartet: number | null;
};

export const initFilterParams = (params?: Partial<FilterParameters> | null): FilterParameters => ({
  raumSapIds: [],
  regionSapIds: [],
  standortSapIds: [],
  locationSapIds: [],
  locationArten: [],
  raumgroesse: null,
  freieTage: null,
  locationHatGruppenraum: null,
  sitzordnung: null,
  teilnehmerErwartet: null,
  ...params,
});

export const hatGruppenraumValues = [
  { value: false, label: 'nicht vorhanden' },
  { value: true, label: 'vorhanden' },
];

const isStringOrNumberArray = (input: unknown): input is number[] | string[] =>
  Array.isArray(input) && input.every((item) => typeof item === 'number' || typeof item === 'string');

export const getSelectedFilterCountText = (
  filterParameters: FilterParameters,
  identifier: keyof FilterParameters,
): string => {
  if (
    identifier === 'raumgroesse' ||
    identifier === 'freieTage' ||
    identifier === 'locationHatGruppenraum' ||
    identifier === 'sitzordnung' ||
    identifier === 'teilnehmerErwartet' ||
    !isStringOrNumberArray(filterParameters[identifier])
  ) {
    return '';
  }

  const count = filterParameters[identifier].length;
  return count > 0 ? `(${count})` : '';
};

export const getAllFilterCountText = (filterParameters: FilterParameters): string => {
  let count = 0;
  if (filterParameters.regionSapIds.length > 0) count++;
  if (filterParameters.standortSapIds.length > 0) count++;
  if (filterParameters.locationSapIds.length > 0) count++;
  if (filterParameters.locationHatGruppenraum !== null) count++;
  if (filterParameters.raumgroesse !== null) count++;
  if (filterParameters.freieTage !== null) count++;
  if (filterParameters.locationArten.length > 0) count++;
  if (filterParameters.sitzordnung !== null && filterParameters.teilnehmerErwartet !== null) count++;
  return count > 0 ? `(${count})` : '';
};
